import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-pregmother-prescription',
  templateUrl: './pregmother-prescription.page.html',
  styleUrls: ['./pregmother-prescription.page.scss'],
})
export class PregmotherPrescriptionPage implements OnInit {

  presentView: any;
  prescriptionHistory: boolean;
  prescription: boolean;
  
  constructor(public router: Router) { }

  ngOnInit() {
  }

  doRefresh(event) {
    console.log('Begin async operation');

    setTimeout(() => {
      console.log('Async operation has ended');
      event.target.complete();
    }, 2000);
  }

  ionViewWillEnter(){
    this.presentView="prescriptionHistory";
    this.prescriptionHistory=true;
    this.prescription=false;
  }
  backToPregnantMother() {
    this.router.navigate(['/tabs/pregnant-mother']);
    this.prescriptionHistory=false;
    this.prescription=false;
  }

  openPrescription() {
    this.presentView="prescription";
    this.prescription=true;
    this.prescriptionHistory=false;
  }
  backToPresHistory() {
    this.presentView="prescriptionHistory";
    this.prescriptionHistory=true;
    this.prescription=false;
  }
}
